var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f88f8f;}.b{clip-path:url(#a);}.c{fill:#4a4c4f;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 80,
    height: 80,
    transform: "translate(1680 155)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-1680 -155)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1700.406 175.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20,6.25A8.75,8.75,0,1,0,28.75,15,8.75,8.75,0,0,0,20,6.25ZM8.75,15A11.25,11.25,0,1,1,20,26.25,11.25,11.25,0,0,1,8.75,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20,26.249A16.25,16.25,0,0,0,5.927,34.375a1.25,1.25,0,1,1-2.165-1.25,18.75,18.75,0,0,1,32.478,0,1.25,1.25,0,1,1-2.165,1.25A16.25,16.25,0,0,0,20,26.249Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfImgPlaceholder);
export default __webpack_public_path__ + "static/media/prof-img-placeholder.87893fde9ae01c29d8c07d92f5875ca7.svg";
export { ForwardRef as ReactComponent };